var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-input',{attrs:{"type":"text"},on:{"change":function($event){return _vm.updated($event.target.value)}},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }